export const CREATE_OFFER = `
mutation(
    $introPerson: ID
    $bountyId: ID
    $relation: String
    $introTime: String
    $comment: String
  ) {
    addNewOffer(
      introPerson: $introPerson
      bountyId: $bountyId
      relation: $relation
      introTime: $introTime
      comment: $comment
    ) {
      id
      created_at
      bountyId {
        fullName
        company
        title
        department
      }
    }
  }
`;

export const CANCEL_OFFER = `
mutation(
  $offerId: ID!
  $status: String
  $cancelReason: String
  $cancelDescription: String
) {
  updateOffer(
    input: {
      where: { id: $offerId }
      data: {
        status: $status
        cancelReason: $cancelReason
        cancelDescription: $cancelDescription
      }
    }
  ) {
    offer {
      id
      status
      created_at
    }
  }
}
`;

export const ACCEPT_OFFER = `
mutation($offerId: ID, $bountyId: ID, $paymentType: String) {
  acceptOffer(offerId: $offerId, bountyId: $bountyId, paymentType: $paymentType) {
    id
  }
}
`;

export const MY_INTROS_COUNT = `
query($introPerson: ID) {
  offersConnection(
    where: { introPerson: $introPerson, status: "accepted", isAccepted: true }
  ) {
    aggregate {
      count
    }
  }
}
`;

export const RESET_MY_INTROS_COUNT = `
mutation($profileId: ID) {
  resetMyIntrosCount(profileId: $profileId) {
    status
  }
}
`;

export const COMPELTE_OFFER = `
mutation($offerId: ID, $rating: Float) {
  completeOrder(offerId: $offerId, rating: $rating) {
    id
    status
  }
}
`;


export const CANCEL_INTRO = `
mutation($offerId: ID!, $cancelReason: String) {
  cancelAcceptedOffer(offerId: $offerId, cancelReason: $cancelReason) {
    id
  }
}
`;